"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var checkReminder = function checkReminder(reminder) {
  var value = localStorage.getItem("react-pwa-alert");
  var isDate = new Date(value) !== "Invalid Date" && !isNaN(new Date(value));
  if (!isDate) return true;
  var currentDate = new Date();
  var date = new Date(value);
  var reminderDate = new Date(date);
  reminderDate.setDate(reminderDate.getDate() + reminder);

  if (currentDate > reminderDate) {
    return true;
  }

  return false;
};

var _default = checkReminder;
exports.default = _default;